'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = shopMiddleware;

var _constants = require('redux/constants');

var _page = require('redux/actions/page');

function shopMiddleware() {
    return function (_ref) {
        var dispatch = _ref.dispatch,
            getState = _ref.getState;

        return function (next) {
            return function (action) {
                switch (action.type) {
                    case _constants.SettingConstants.SET_SETTING:
                    case _constants.SettingConstants.LOAD_SETTINGS_SUCCESS:
                        next(action);
                        dispatch((0, _page.setSettingPage)(action.result.onlineShopPages));
                        break;
                    default:
                        break;
                }

                return next(action);
            };
        };
    };
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/middleware/shopMiddleware.js
// module id = 1890
// module chunks = 0